import { observer } from 'mobx-react-lite';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import styles from './NewExpensePopup.module.css';
import { X } from 'lucide-react';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
}

const DeleteConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message = 'Bu işlemi geri alamazsınız.',
}: DeleteConfirmationDialogProps) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={e => e.stopPropagation()}>
        <div className={styles.popupHeader}>
          <h3 className={styles.popupTitle}>{title}</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <p style={{ margin: 0, color: '#666', lineHeight: '1.5' }}>{message}</p>
        </div>

        <div className={styles.buttonGroup}>
          <CommonButton type="secondary" onClick={onClose}>
            İptal
          </CommonButton>
          <CommonButton type="primary" onClick={handleConfirm}>
            Sil
          </CommonButton>
        </div>
      </div>
    </div>
  );
};

export default observer(DeleteConfirmationDialog);
